/**
 * Koder för tidrapportering i Fortnox.
 *
 * Fortnox skiljer på närvaro (`/attendancetransactions`) och frånvaro
 * (`/absencetransactions`) och avvisar koder som hör till den andra sidan. Det
 * här är alltså två skilda listor — SEM går till frånvaro, ARB till närvaro.
 */

/** Närvarokoder, i den ordning de är rimliga att välja bland. */
export const ATTENDANCE_CAUSE_CODES = [
  "ARB",
  "TID",
  "MER",
  "OT1",
  "OT2",
  "OT3",
  "OT4",
  "OT5",
  "OK0",
  "OK1",
  "OK2",
  "OK3",
  "OK4",
  "OK5",
  "OB1",
  "OB2",
  "OB3",
  "OB4",
  "OB5",
  "JOR",
  "JO2",
  "BER",
  "BE2",
  "RES",
  "HLG",
  "FLX",
] as const;

export type AttendanceCauseCode = (typeof ATTENDANCE_CAUSE_CODES)[number];

export const ATTENDANCE_CAUSE_LABELS: Record<AttendanceCauseCode, string> = {
  ARB: "Arbetstid (timlön)",
  TID: "Arbetstid inom schema",
  MER: "Mertid",
  OT1: "Övertid 1 – betalning",
  OT2: "Övertid 2 – betalning",
  OT3: "Övertid 3 – betalning",
  OT4: "Övertid 4 – betalning",
  OT5: "Övertid 5 – betalning",
  OK0: "Extratid – komptid",
  OK1: "Övertid 1 – komptid",
  OK2: "Övertid 2 – komptid",
  OK3: "Övertid 3 – komptid",
  OK4: "Övertid 4 – komptid",
  OK5: "Övertid 5 – komptid",
  OB1: "OB-ersättning 1",
  OB2: "OB-ersättning 2",
  OB3: "OB-ersättning 3",
  OB4: "OB-ersättning 4",
  OB5: "OB-ersättning 5",
  JOR: "Jourtid 1",
  JO2: "Jourtid 2",
  BER: "Beredskapstid 1",
  BE2: "Beredskapstid 2",
  RES: "Restid",
  HLG: "Helglön",
  FLX: "Flextidssaldo",
};
